<template>
    <Modal>
        <ModalCard
            @cancel="cancel"
            :activeValidate="nomZipValid"
            :headerTitle="$t('document.rapports.modal.nom.zip.header')"
            @confirm="download"
        >
            <span>{{$t('document.rapports.modal.nom.zip.choix.label')}}</span>
            <div>
                <input v-model='nomZip'>
                <span>{{$t('document.rapports.modal.nom.zip.extension')}}</span>
            </div>
        </ModalCard>
    </Modal>
</template>
<script lang='ts'>
import { defineComponent } from 'vue';
import Modal from '@/components/ui-components/Modal.vue';
import ModalCard from '@/components/ui-components/ModalCard.vue';

interface Data {
    nomZip: string | undefined;
}

export default defineComponent({
    name: 'ModalChoixNomZip',
    components: {
        ModalCard,
        Modal
    },
    data(): Data {
        return {
            nomZip: undefined
        };
    },
    methods: {
        cancel(): void {
            this.$emit('cancel');
        },
        download(): void {
            this.$emit('download', this.nomZip);
        }
    },
    computed: {
        nomZipValid() : boolean {
            return this.nomZip !== undefined && this.nomZip.trim() !== '';
        }
    }
});
</script>
<style lang="scss" scoped>

</style>
